import React, { useEffect, useState } from "react";
import {
    Paper,
    makeStyles,
    Button,
    Box,
    IconButton,
    Backdrop,
    CircularProgress,
    Chip,
    Tooltip,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import {
    deletePermission,
    fetchRolesWithPermission,
    deleteRoleWithPermission
} from "../../store/action/permission/permissionAction";
import AlertDialog from "../../components/Alert/AlertDialog";
import Notification from "../../components/Notification/Notification";
import Loading from "../../components/Loading/Loading";

const useStyle = makeStyles((theme) => ({
    root: {
        width: "100%",
        padding: 24,
        borderRadius: 16,
        background: "linear-gradient(145deg, #ffffff, #f3f4f6)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    permissionChip: {
        margin: "4px",
        borderRadius: 12,
        fontWeight: 500,
    },
    accordion: {
        borderRadius: 12,
        overflow: "hidden",
        background: "linear-gradient(145deg, #f9fafb, #ffffff)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        transition: "transform 0.2s ease-in-out",
        '&:hover': {
            transform: "translateY(-2px)",
        },
    },
}));

const ViewRole = ({ match }) => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [Id, setId] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const { roleswithPermissionSuccess, roleswithPermissionError, loading } = useSelector(
        (state) => state.permission
    );
    const { roleSuccess, roleErrors } = useSelector((state) => state.roles);
    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleClose1 = () => setEditOpen(false);

    const deleteRole = (role_id) => {
        setDisabled(true);
        setId(role_id);
        setDeleteOpen(true);
    };


    const editRole = (role_id) => {
        setId(role_id);
        setEditOpen(true);
    };

    const deleteRoleClose = () => {
        setDeleteOpen(false);
    };

    const alertResponse = (id) => {
        if (disabled === true) {
            dispatch(deleteRoleWithPermission(id));
        }
        setDisabled(false);
    };

    useEffect(() => {
        dispatch(fetchRolesWithPermission());
    }, [dispatch]);
    console.log(roleswithPermissionSuccess, "roleswithPermissionSuccess");
    console.log(roleswithPermissionError, "roleswithPermissionError");
    return (
        <>
            {loading && <Loading open={loading} />}

            {roleswithPermissionError?.message && (
                <Notification data={roleswithPermissionError?.message} status="error"/>
            )}
            {roleswithPermissionSuccess?.message && (
                <Notification data={roleswithPermissionSuccess?.message} status="success"/>
            )}
            <Paper className={`${classes.root} mb-6`}>
                {/* Notifications */}

                <Box className="mb-5" display="flex" alignItems="center" justifyContent="flex-end">
                    <Link to={`${match.path}/create`} className="btn btn-secondary">
                        <AddIcon className="mr-2" />
                        Add Role
                    </Link>
                </Box>

                {roleswithPermissionSuccess?.data?.length > 0 ? (
                    roleswithPermissionSuccess.data.map((role, index) => (
                        <Accordion key={role.role_id} className={`${classes.accordion} mb-3`}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel${index}-content`} id={`panel${index}-header`}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {index + 1}. {role.role_name}
                                    </Typography>
                                    <Box>
                                        <Tooltip title="Edit Role">
                                            <IconButton
                                                component={Link}
                                                to={`${match.path}/${role.role_id}/detail`}
                                                size="small"
                                            >
                                                <EditIcon color="primary" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete Role">
                                            <IconButton
                                                onClick={() => deleteRole(role.role_id)}
                                                size="small"
                                            >
                                                <DeleteIcon color="secondary" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                {role.permission_names.length > 0 ? (
                                    <Box display="flex" flexWrap="wrap">
                                        {role.permission_names.map((perm, i) => (
                                            <Chip
                                                key={i}
                                                label={perm}
                                                className={classes.permissionChip}
                                                color="primary"
                                                variant="outlined"
                                            />
                                        ))}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="textSecondary">
                                        No permissions assigned.
                                    </Typography>
                                )}
                            </AccordionDetails>
                        </Accordion>
                    ))
                ) : (
                    <Typography align="center" color="textSecondary">
                        No roles available
                    </Typography>
                )}
            </Paper>

            <AlertDialog
                id={Id}
                response={alertResponse}
                open={deleteOpen}
                close={deleteRoleClose}
                title="Delete Roles Assign with Permission"
                description="Are you sure you want to delete role with permission?"
                buttonName="Delete"
            />

        </>
    );
};

export default ViewRole;
